<script setup>
import { ref, computed } from 'vue';
import { useMessageContext } from '../provider.js';
import BaseBubble from 'next/message/bubbles/Base.vue';

const { content, contentAttributes } = useMessageContext();

const items = computed(() => {
  return contentAttributes.value.items || [];
});
</script>

<template>
  <BaseBubble class="p-3 overflow-hidden" data-bubble-name="article">
    <div v-if="content" class="mb-2">{{ content }}</div>
    <div v-for="item in items" :key="item.title" class="mb-2">
      <h3 class="font-bold">{{ item.title }}</h3>
      <p>{{ item.description }}</p>
      <a :href="item.link" target="_blank" class="text-blue-500">{{
        item.link
      }}</a>
    </div>
  </BaseBubble>
</template>
